import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

import "../../components/css/Loading.css";
import "./Certificados.css";

export const Certificados = () => {
  const { identificacion } = useParams();
  const documento = identificacion;
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState("divPadre");
  const navigate = useNavigate();

  // Devuelve la ruta desde la que el usuario hizo la consulta, para
  // volver al diseno correcto (extension o clasico) cuando hay un error.
  // Si no hay origen guardado, usa "/" (diseno por defecto).
  const getOrigin = () => sessionStorage.getItem("registerOrigin") || "/";

  useEffect(() => {
    // === TEMPORAL: datos de ejemplo para previsualizar el diseno sin backend ===
    // Se activa solo con REACT_APP_MOCK_CERTS=true en el .env. Quitar antes de commitear.
    if (process.env.REACT_APP_MOCK_CERTS === "true") {
      setLoading("divPadre");
      setLista([
        {
          certificadoId: 27421,
          fechaCarga: "2025-10-30",
          info_curso: {
            nombreCurso:
              "Encuentro Nacional de Centros de Innovación Educativa: Metodologías que Transforman",
            nombreCurso2: "",
            horas: 0,
            url_encuesta: "",
          },
        },
        {
          certificadoId: 22727,
          fechaCarga: "2024-12-10",
          info_curso: {
            nombreCurso: "Herramientas Básicas en la Nube",
            nombreCurso2: "",
            horas: 48,
            url_encuesta: "",
          },
        },
        {
          certificadoId: 21020,
          fechaCarga: "2024-10-04",
          info_curso: {
            nombreCurso: "Introducción al Diseño Instruccional",
            nombreCurso2: "",
            horas: 48,
            url_encuesta: "",
          },
        },
        {
          certificadoId: 20110,
          fechaCarga: "2024-07-02",
          info_curso: {
            nombreCurso:
              "Inducción - Reinducción de la Institución Universitaria Digital de Antioquia",
            nombreCurso2: "",
            horas: 48,
            url_encuesta: "https://forms.gle/ejemplo",
          },
        },
      ]);
      return;
    }
    // === FIN TEMPORAL ===

    axios
      .get(
        `${process.env.REACT_APP_API_URL}certificados_estudiante/${documento}`
      )
      .then((response) => {
        console.log("a");
        setLoading("divPadre");
        if (response.data.code == 404) {
          alert("Documento " + documento + " no se encuentra registrado");
          window.location.href = getOrigin();
        } else {
          if (
            Array.isArray(response.data.data.certificados) &&
            response.data.data.certificados.length === 0
          ) {
            alert(
              "Documento " + documento + " no tiene certificados asociados"
            );
            window.location.href = getOrigin();
          } else {
            setLista(response.data.data.certificados);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        alert(
          "¡Ups! Algo salió mal. Por favor, contacta a soportecampus@iudigital.edu.co"
        );
        window.location.href = getOrigin();
      });
  }, []);

  const getPdf = async (certificadoId) => {
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}estudiante/certificado/generateCertificate/${certificadoId}`,
        { responseType: "blob" }
      )
      .then((response) => {
        let fileName = response.headers
          .get("Content-Disposition")
          .split("filename=")[1]
          .replace(/['"]+/g, ""); // Nombre predeterminado

        setLoading("divPadre");
        const url = window.URL.createObjectURL(response.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName; // Utilizar el nombre del archivo obtenido
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.log(error);
        alert(
          "¡Ups! Algo salió mal. Por favor, contacta a soportecampus@iudigital.edu.co"
        );
      });
  };

  const cambiarEstado = (certificadoId) => {
    setLoading("divPadre activo");
    getPdf(certificadoId);
  };

  const esURL = (url) => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return false;
    }
  };

  return (
    <div className="cert-list">
      {lista.length > 0 && (
        <>
          {/* Encabezado */}
          <div className="cert-header">
            <div className="cert-header-left">
              <div className="cert-topline"></div>
              <h2 className="cert-title">Tus certificados</h2>
              <p className="cert-subtitle">
                Encontramos {lista.length}{" "}
                {lista.length === 1
                  ? "certificado asociado"
                  : "certificados asociados"}{" "}
                al documento <strong>{documento}</strong>.
              </p>
            </div>
            <button
              type="button"
              className="cert-back"
              onClick={() => navigate(-1)}
            >
              <span className="cert-back-text">Regresa a Consulta</span>
              <img
                src="/weui_arrowdown-outlined.svg"
                alt=""
                className="cert-back-icon"
              />
            </button>
          </div>

          {/* Tabla de certificados */}
          <div className="cert-table-wrap">
            <table className="cert-table">
              <thead>
                <tr>
                  <th>ID Certificado</th>
                  <th>Nombre del curso</th>
                  <th className="col-center">Horas</th>
                  <th className="col-center">Fecha</th>
                  <th className="col-center">Encuesta</th>
                  <th className="col-center">Descarga</th>
                </tr>
              </thead>
              <tbody>
                {lista.map((item) => (
                  <tr key={item.certificadoId}>
                    <td className="col-id" data-label="ID Certificado">
                      {item.certificadoId}
                    </td>
                    <td data-label="Nombre del curso">
                      {item.info_curso.nombreCurso}{" "}
                      {item?.info_curso?.nombreCurso2}
                    </td>
                    <td className="col-center" data-label="Horas">
                      {item.info_curso.horas}
                    </td>
                    <td className="col-center" data-label="Fecha">
                      {new Date(item.fechaCarga).toLocaleDateString("es-ES")}
                    </td>
                    <td className="col-center" data-label="Encuesta">
                      {esURL(item.info_curso.url_encuesta) ? (
                        <a
                          className="link-encuesta"
                          href={item.info_curso.url_encuesta}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Encuesta
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td className="col-center" data-label="Descarga">
                      <button
                        type="button"
                        className="btn-download"
                        title="Descargar PDF"
                        onClick={() => cambiarEstado(item.certificadoId)}
                      >
                        <img
                          src="/Vector.svg"
                          alt="Descargar PDF"
                          className="btn-download-icon"
                        />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Aviso inferior */}
          <div className="cert-notice">
            <img src="/Icon.svg" alt="" className="cert-notice-icon" />
            <span>
              ¿No encuentras un certificado o tienes problemas con la descarga?
              Escríbenos a{" "}
              <a href="mailto:contacto@iudigital.edu.co">
                contacto@iudigital.edu.co
              </a>
            </span>
          </div>
        </>
      )}

      <div className={loading}>
        <div className="divHijo">
          <div className="spinner-grow" role="status"></div>
          <br />
          <p>Estamos creando tu certificado...</p>
        </div>
      </div>
    </div>
  );
};
